// extracted by mini-css-extract-plugin
export var container = "_54-0";
export var icon = "_54-1";
export var text = "_54-2";